<template>
	<div class="wrap wrap--sub">
		<!-- 헤더 -->
		<main-header></main-header>

		<!-- 메인 -->
		<main class="main" role="main">
			<div class="page-head">
				<div class="page-head__inner">
					<h1 class="page-head__title">COMPANY</h1>
					<!-- <p class="page-head__route">Home<span></span>회사소개</p> -->
				</div>
			</div>
			<div class="company-section1">
                <div class="container">
                    <div class="con1">
                        <h2>Established Corporation, specialized only in Wallpaper</h2>
                        <p>Wallpapers of DID inherit 70 years of master craftsmanship handed down for 3 generations. <br class="pc" />With long accumulated, vast database of wallpaper designs, DID has set the trends of Korean wallpaper market. <br class="pc" />Furthermore, DID put efforts on and circles on the ideas of Customer-Oriented management, <br class="pc" />to fulfill customer needs and wants, and Sustainable management, <br class="pc" />to preserve nature as healthy as it is for the future generations. <br class="pc" />"D&D/4U" which introduced the concept of Point Wallpaper, <br class="pc" />"Velvet", luxury silk wallpapers, the first implementation of Screen Gravure Technology in the world, <br class="pc" />and "Color", the beginning of the Plain Wallpaper trend. <br class="pc" />DID constantly endeavours to bring great and novelty products, fulfilling the customers.</p>
                    </div>
                    <div class="con2">
                        <div class="mark"><img src="/images/sub/company/mark.png" alt=""></div>
                        <h3>No. 1 Export <br />Wallpaper Corporation <br />of World-class</h3>
                        <p>DID is the sole Korean silk wallpaper corporation <br class="pc" />which participates in Heimtextil, Germany, <br class="pc" />the largest exhibition in the global wallpaper market. <br class="pc" />As one of the major exhibitors of Heimtextil, <br class="pc" />DID promotes the excellency of Korean wallpapers. <br class="pc" />DID wallpapers are sold in 48 nations world-wide, <br class="pc" />from Europe, the home of wallpaper, <br class="pc" />to United States of America, of sophisticated customers.</p>
                    </div>
                    <div class="con3">
                        <img src="/images/sub/company/model.png" alt="">
                    </div>
                    <div class="line container"></div>
                </div>
			</div>
			<div class="company-section2">
				<div class="container">
					<div class="global">
						<h4>GLOBAL LEADING TECHNOLOGY</h4>
						<h3>Global-Leading <br class="pc"/>Technology</h3>
						<div><img src="/images/sub/company/global_img.png" alt=""></div>
						<p>DID proudly introduces various cutting-edge products to the world, with world-class, competitive technologies; Advanced Automatic Color Matching System, Automated Production Facility with Digital Control System, Optical and Laser Inspection Equipments and other Production technologies exceeding European standards. Launching the very first of the kinds, Combination products of Screen and Gravure, Wiping and Top Print, and Islandic Embossed products, DID has shown excellency of Korean wallpapers.</p>
					</div>
					<div class="world">
						<h4>WORLD BEST DESIGN</h4>
						<h3>Design, Praised<br class="pc"/>by the customers of Europe, <br class="pc"/>the Home of Wallpaper</h3>
						<div><img src="/images/sub/company/world_img.png" alt=""></div>
						<p>Introducing creative and differentiated products, resulted by continuous investments in Design R&D, DID has been recognized from sophisticated Europe wallpaper market as a Unique maker. From collaborating with world's leading wallpaper design companies and famed European Designers, to consulting of coloring at the highest level, DID practices extravagnt, yet, refined values of European luxury brands on domestic places and trends.</p>
					</div>
				</div>
				<a id="green"></a>
			</div>

			<div class="company-section3">
                <img class="pc" src="/images/sub/company/eco.jpg" alt="Healthy Wallpaper for the People, the Luxury Wallpaper, DID. DID Wallpapers are certified products for Eco-friendliness and Health Safety.">
                <img class="mo" src="/images/sub/company/eco-mo.jpg" alt="Healthy Wallpaper for the People, the Luxury Wallpaper, DID. DID Wallpapers are certified products for Eco-friendliness and Health Safety.">
			</div>

			<div class="company-section4">
				<div class="container">
					<div class="certification">
						<h4>Inhibiting Fungal Growth</h4>
						<h3><span>Anti-Fungal</span> Certification</h3>
						<div class="line"></div>
						<div class="cer_img"><img src="/images/sub/company/certification_1.png" alt=""></div>
						<p>Anti-Fungal Certification products which inhibits <br class="pc" />Fungal Growth <br class="pc" />with Anti-Fungus Technology</p>
					</div>
					<div class="certification">
						<h4>Prevented Sick House Syndrome</h4>
						<h3><span>Eco-Friendliness</span> Certification</h3>
						<div class="line"></div>
						<div class="cer_img"><img src="/images/sub/company/certification_2.png" alt=""></div>
						<p>Eco-Reliable products with Certified Eco Marks. No worries about HCHO and TVOCs which causes Sick House Syndrome.</p>
					</div>
					<div class="certification">
						<h4>Reduced Atopy Worries</h4>
						<h3><span>Healthy</span> Products</h3>
						<div class="line"></div>
						<div class="cer_img"><img src="/images/sub/company/certification_3.png" alt=""></div>
						<p>Recommended products from evaluation by Korean Atopy Association. Products that Safe and Reliable to use.</p>
					</div>
					<div class="certification">
						<h4>Strict and Safe</h4>
						<h3><span>Quality</span> Control</h3>
						<div class="line"></div>
						<div class="cer_img"><img src="/images/sub/company/certification_4.png" alt=""></div>
						<p>Certified products for Quality Control by International Organization for Standardization and Korean Standards Association.</p>
					</div>
				</div>
			</div>

			<div class="company_line container"></div>

			<div class="company-section5">
				<div class="container">
					<div class="location-left">
						<h3><span><img src="" alt=""></span>Location</h3>
						<div class="in-box">
							<h4>DID Wallpaper</h4>
							<p>10th, 12th floor, Gungdo Bldg, 327, Bongeunsa-ro, Gangnam-gu, Seoul, Republic of Korea</p>
							<p><strong>TEL</strong> 02-2141-3930</p>
						</div>
                        <!-- <div class="in-box">
							<h4>Family Shop</h4>
							<p><a href="/family-shop">패밀리샵이 궁금하시다면?</a></p>
						</div> -->
					</div>
					<div class="location-right">
						<div class="map">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1330.677981265544!2d127.04157118190216!3d37.51019535649325!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca409831e219d%3A0xc6e08ebd6bb8103!2zKOyjvCnrlJTslYTsnbTrlJQ!5e0!3m2!1sko!2skr!4v1612419071861!5m2!1sko!2skr" width="100%" height="100%" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
						</div>
					</div>
				</div>
			</div>
		</main>

		<!-- 푸터 -->
		<main-footer></main-footer>
	</div>
</template>

<script>
import MainHeader from "../../../components/client/inc/main-header.vue";
import MainFooter from "../../../components/client/inc/main-footer.vue";

export default{
	components: {
		MainHeader,
		MainFooter
	},
	created() {
	},
	mounted() {
		this.init();
	},
	methods : {
		init : function() {
		}
	},
}
</script>
